import { Platform, TextInput, TextInputProps } from 'react-native'

import { BottomSheetTextInput as BSTI } from '@gorhom/bottom-sheet'

export const BottomSheetTextInput = (props: TextInputProps) =>
    Platform.OS === 'web' ? <TextInput {...props} /> : <BSTI {...props} />
